export default __webpack_public_path__ + "static/media/carrito.d1bc4bb4.svg";